module.exports = __webpack_public_path__ + "img/full6-min.20fad2e2.png";